import SimpleDate from 'app/common/classes/simple-date'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'

import styles from './PrevioslyUnacceptedInfo.module.scss'

type Props = {
  dates: Array<SimpleDate>
}

export const PrevioslyUnacceptedInfo = ({ dates }: Props) => {
  console.log(
    'PrevioslyUnacceptedInfo',
    dates,
    dates.map((date) => date.getStringFormatted('DD.MM.YYYY')),
  )
  return (
    <PlainTooltip
      text={`Имеются незавершенные операции за предыдущие дни: ${dates.map((date) => date.getString('DD.MM.YYYY')).join(', ')}`}
    >
      <span className={styles.root}>{'[ ! ]'}</span>
    </PlainTooltip>
  )
}
